
import { Link } from "react-router-dom";

import './Home.css'
import Inicio from "../../components/Inicio/Inicio";
import IntroInfo from "../../components/IntroInfo/IntoInfo";

function Home(){
 
  return(
    <div className="container">
   <Inicio/>
  <IntroInfo/>
    </div>
  )
}

export default Home;